export default __webpack_public_path__ + "static/media/microfleece_v_pant.762d7240.jpg";